module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "Ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg9"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGEMENTS")])])]), _c('a', {
    attrs: {
      "id": "pg9"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I would like to acknowledge all the help and support that I obtained while writing this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First and foremost, I would like to thank my wife, Jennifer, for all the assistance that she gave to me while I was researching this book. From keeping me company during the long drives to waiting patiently while I conducted interviews or took photographs, your support, love and companionship made the research behind this book extremely enjoyable. Also, special thanks to my son Sean Steed for riding “shotgun” with me throughout Northwest Arkansas while I was taking additional photos for the book, even though I was sick with the flu.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would also like to extend my thanks to Matt Wallace, Matthew Massey, Bert Casper and everyone at SMC Packaging Group for their support. The willingness of everyone to stand there patiently while I rambled on about one haunting or another that I had just discovered or a paranormal investigation that I was about to embark on is truly amazing, not to mention much appreciated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Special thanks to Keith Scales, the director of ghost tours for both the Crescent and Basin Park Hotels, for taking the time to speak with me and share some of the history and some interesting stories of the alleged hauntings of both properties; your knowledge and time are greatly appreciated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Last but not least, thanks to everyone who shared their stories with me about their paranormal experiences in Northwest Arkansas; it was great fun speaking with all of you and hearing your stories.")])]), _c('p', {
    staticClass: "lev1"
  }, [_c('a', {
    attrs: {
      "id": "pg9"
    }
  }), _c('a', {
    attrs: {
      "id": "pg10"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISCLAIMER")])])]), _c('a', {
    attrs: {
      "id": "pg10"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("While I have strived to ensure the accuracy of the stories and the history behind them, I think that it is important to remember that they are, indeed, just ghost stories. Whether they are factual or not is impossible to say, as no one has ever proven the existence of life after death. When possible, I have included in the stories personal experiences obtained during investigations and during research trips, but that is in no way definitive proof that a haunting is going on at that particular site; it simply means that I had an experience that I couldn’t debunk or find a logical answer for. Additionally, those stories that I can find very little truth behind, or are questionable at best in regard to any factual basis, are still included; even if they are nothing more than urban legend, they are still entertaining and show the process and evolution of the storytelling and legends associated with the area.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All in all, I hope that you enjoy this book and that the stories of ghosts and hauntings might move you to do a little investigating of your own, to seek the truth behind the stories, a task that brings me great joy and fulfillment, as I am sure it will you as well. Read the stories, check into them a little further if you like and come to your own conclusions as to what is true and what is simply an urban legend, but above all else, just have fun with it and enjoy the stories!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5abd810","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgement.vue
// module id = 72
// module chunks = 0